const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowRescheduleDelivery', ['RescheduleDeliveryService','MissedDeliveryService', 'GoogleCaptchaService', 'SettingsService', '$stateParams','$location','$rootScope', 'AtmService', require('./rescheduledelivery-directives')]);
wowApp.service('RescheduleDeliveryService', ['Restangular','ProxyService', '$http', require('./rescheduledelivery-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/rescheduledelivery/index.js
 **/